import { browser } from '$app/environment';

export type Theme = 'dark' | 'light';

/** Get the current theme from localStorage, defaulting to 'dark'. */
export function getTheme(): Theme {
	if (!browser) return 'dark';
	const stored = localStorage.getItem('color-theme');
	if (stored === 'light' || stored === 'dark') return stored;
	return 'dark';
}

/** Set the theme in localStorage and update the document's data-theme attribute. */
export function setTheme(theme: Theme) {
	if (!browser) return;
	localStorage.setItem('color-theme', theme);
	document.documentElement.dataset.theme = theme;
}

/** Toggle between dark and light themes, returning the new theme. */
export function toggleTheme(): Theme {
	const current = getTheme();
	const next: Theme = current === 'dark' ? 'light' : 'dark';
	setTheme(next);
	return next;
}
